var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.069,
    height: 13.771,
    viewBox: "0 0 14.069 13.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173975",
    "data-name": "Path 173975",
    d: "M.915,6.407a3.358,3.358,0,0,1,.99.185,13.7,13.7,0,0,1,1.943.824c.231.114.459.233.687.353a.086.086,0,0,0,.125-.024C5.379,6.926,6.09,6.1,6.826,5.294a45.147,45.147,0,0,1,3.595-3.576,11.9,11.9,0,0,1,1.722-1.3,2.985,2.985,0,0,1,.89-.384A1.035,1.035,0,0,1,13.754.1a.537.537,0,0,1,.312.433.551.551,0,0,1-.092.377,2.645,2.645,0,0,1-.3.376c-.4.4-.8.782-1.2,1.174A28.272,28.272,0,0,0,8.185,7.859,36.086,36.086,0,0,0,5.4,13.466a.417.417,0,0,1-.336.3.4.4,0,0,1-.435-.212c-.17-.294-.337-.59-.509-.883a28.815,28.815,0,0,0-1.724-2.655A16.114,16.114,0,0,0,.205,7.624.556.556,0,0,1,.031,7a.808.808,0,0,1,.7-.579l.179-.013",
    transform: "translate(0 0)",
    fill: "#ed1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.12d0229d8d4af0a3b9eef674fe833a8e.svg";
export { ForwardRef as ReactComponent };